import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DealBox } from "../components/DealBox";
import { DealProductsDialog } from "./DealProductsDialog";
import { SubTitledDealBox } from "../components/SubTitledDealBox";
import { EmptyDealBox } from "../components/EmptyDealBox";
import { PizzaModifiersDialog } from "./PizzaModifiersDialog";
import { getPizzaSizes, getPizzaSpecialDeals } from "../apis/RangerOnlineApi";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { PizzaDialog } from "./PizzaDialog";
import { AlertPopUp } from "../components/AlertPopUp";

let currDealIndex = 0;

const pad = (str, length, char = " ") => {
  return str.padStart((str.length + length) / 2, char).padEnd(length, char);
};

const getPizzas = (pizzaToppingPrices, sizeId, toppingQty) => {
  let pizzaCount = 0;
  let boxes = [];
  const pizzasPrices = pizzaToppingPrices.find(
    (x) => x.sizeId == sizeId && x.toppingQty == toppingQty
  );
  if (pizzasPrices) {
    for (let i = 1; i <= 8; i++) {
      if (pizzasPrices[`toppingPrice${i}`] === 0) {
        pizzaCount = i - 1;
        break;
      }
      //   boxes.push(
      //     <DealBox
      //       key={i + 1}
      //       children={
      //         <EmptyDealBox
      //           index={i}
      //           description={`Add pizza #${i}`}
      //           onClick={handleDealOpen}
      //         />
      //       }
      //     />
      //   );
    }
  }

  return pizzaCount;
};

export const CYOPizzaDialog = (props) => {
  const {
    open,
    onClose,
    product,
    variationConfig,
    variations,
    showLoader,
    closeLoader,
    onProductAdd,
    steps,
  } = props;

  const [productCopy, setProductCopy] = useState({ ...product });
  const [openSelection, setOpenSelection] = useState(false);
  const [openModifiers, setOpenModifiers] = useState(false);
  const [pizzaSizeId, setPizzaSizeId] = useState("");
  const [defaults, setDefaults] = useState({});
  const [deals, setDeals] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleAlert = (show, message) => {
    setShowAlert(show);
    setAlertMessage(message);
  };

  const handleDealOpen = (index) => {
    currDealIndex = index;
    setOpenSelection(true);
  };

  const handleAddToDeal = (product) => {
    const dealsCopy = [...deals];
    dealsCopy[currDealIndex] = product;

    setOpenSelection(false);
    setDeals(dealsCopy);
  };

  const getToppingPrices = (sizeId, toppingQty, pizzaCount) => {
    let obj = {};
    const pizzaToppingPrices = [...productCopy.pizzaToppingPrices];
    obj = pizzaToppingPrices.find(
      (x) => x.sizeId == sizeId && x.toppingQty == toppingQty
    );

    if (!obj) {
      obj = pizzaToppingPrices
        .filter((x) => x.sizeId == sizeId && x[`toppingPrice${pizzaCount}`] > 0)
        .reduce(function (prev, current) {
          return prev.toppingQty > current.toppingQty ? prev : current;
        });
    } else if (obj[`toppingPrice${pizzaCount}`] === 0) {
      obj = getToppingPrices(sizeId, toppingQty - 1, pizzaCount);
    }

    return obj;
  };

  const handleSizeChange = (e) => {
    const sizeId = e.target.value;
    //let newDefaults = { ...defaults };
    /*const price = defaults.pizzaSizes.find(
      (x) => x.sizeId == sizeId
    ).sizePriceX1;*/
    /*let newProduct = { ...productCopy };
    newProduct.price = price;*/
    if (deals.filter((x) => Object.keys(x)).length > 0) {
    }
    //setProductCopy({ ...newProduct });
    setPizzaSizeId(sizeId);
  };

  const handleAddModifiers = (modifiers) => {
    let newProduct = { ...product };
    newProduct.modifiersDescription = modifiers.modifiersDescription;
    newProduct.modifiersSubititle = modifiers.modifiersSubititle;
    newProduct.selectedVariations = [...modifiers.selectedVariations];
    newProduct.variationsPrice = modifiers.modifiersPrice;

    setProductCopy(newProduct);
    setOpenModifiers(false);
  };

  const handleRemoveDeal = (dealIndex) => {
    const dealsCopy = [...deals];
    dealsCopy[dealIndex] = {};

    setDeals(dealsCopy);
  };

  const getBoxContent = (type, index, props) => {
    const { productName, modifiers, onRemoveClick } = props || {};
    let content = null;
    switch (type) {
      case "filled":
        content = (
          <SubTitledDealBox
            productName={productName}
            modifiers={modifiers}
            onRemoveClick={onRemoveClick}
            index={index}
          />
        );
        break;
      case "empty":
        content = (
          <EmptyDealBox
            index={index}
            description={`Add pizza #${index + 1}`}
            onClick={handleDealOpen}
          />
        );
        break;
      default:
        return null;
    }

    return content;
  };

  const handleSaveChanges = () => {
    let finalProduct = { ...productCopy };
    let finalDescription = ""; //pad(` ${productCopy.productName} `, 28, "-");
    const validDeals = deals.filter((x) => Object.keys(x).length > 0);
    let itemCount = validDeals.length;
    let pizzaPricePerTopping = {};
    let pizzaPrice = 0;
    let toppingFinalPrice = 0;

    validDeals.map((x, index) => {
      let price = 0;
      let toppingCount = x?.toppings?.length || 0;
      pizzaPricePerTopping = getToppingPrices(
        pizzaSizeId,
        toppingCount,
        itemCount
      );
      price = pizzaPricePerTopping[`toppingPrice${itemCount}`];

      if (price > pizzaPrice) {
        pizzaPrice = price;
      }
      let toppingPrice = 0;
      if (toppingCount > pizzaPricePerTopping.toppingQty) {
        x?.toppings.map((x, i) => {
          i++;
          if (i > pizzaPricePerTopping.toppingQty) {
            toppingPrice += x.pizzaModifierPrice;
          }
        });
      }

      const description =
        index > 0
          ? `\r\n-------------------\r\n${x.fullDescription}`
          : x.fullDescription;

      toppingFinalPrice += toppingPrice;
      finalDescription = finalDescription + description;
    });

    finalProduct.price = pizzaPrice + toppingFinalPrice;
    finalProduct.totalPrice = pizzaPrice + toppingFinalPrice;

    if (
      productCopy?.selectedVariations &&
      productCopy?.selectedVariations.length > 0
    ) {
      finalDescription =
        finalDescription +
        `\n-------------------\n${productCopy.modifiersSubititle}\n`;
    }
    finalProduct.fullDescription = finalDescription;
    onProductAdd(finalProduct);
  };

  useEffect(() => {
    showLoader();
    const getDefaults = async () => {
      const response = await getPizzaSpecialDeals(product.productId);
      const sizes = await getPizzaSizes(product.productId);
      if (response?.status) {
        return;
      }

      if (sizes?.status) {
        handleAlert(true, "Error could not find sizes for this pizza.");
        closeLoader();
        return;
      }

      closeLoader();
      setPizzaSizeId(sizes[0].sizeId);
      setDefaults({ dealProducts: response, pizzaSizes: sizes });
      setDeals(
        new Array(
          getPizzas(product?.pizzaToppingPrices, sizes[0].sizeId, 0)
        ).fill({})
      );
    };

    getDefaults();
  }, []);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>{product.productName}</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
          paddingBottom: "16px",
        }}
      >
        <Grid container gap={1}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="Pizza Size Selector" sx={{ marginTop: "5px" }}>
                Size:
              </InputLabel>
              <Select
                labelId="Pizza Size Selector"
                id="pizzaSize"
                value={pizzaSizeId}
                label="Size:"
                onChange={handleSizeChange}
              >
                {defaults?.pizzaSizes
                  ? defaults.pizzaSizes.map((x, index) => (
                      <MenuItem
                        key={index}
                        value={x.sizeId}
                      >{`${x.sizeName}`}</MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          {deals.map((x, index) => {
            let children = null;
            if (x?.productName) {
              const props = {
                productName: x.productName,
                modifiers: x.modifiers,
                onRemoveClick: () => handleRemoveDeal(index),
                index: index,
              };
              children = getBoxContent("filled", index, props);
            } else {
              children = getBoxContent("empty", index);
            }

            return (
              <Grid item xs={12}>
                <DealBox key={index} children={children} />
              </Grid>
            );
          })}

          <Grid item xs={12}>
            {variations && variations.length > 0 ? (
              productCopy?.selectedVariations &&
              productCopy?.selectedVariations.length > 0 ? (
                <DealBox
                  key={deals.length + 1}
                  children={
                    <SubTitledDealBox
                      modifiers={productCopy.modifiersDescription}
                      onRemoveClick={handleRemoveDeal}
                    />
                  }
                />
              ) : (
                <DealBox
                  key={deals.length + 1}
                  children={
                    <EmptyDealBox
                      index={deals.length + 1}
                      description={`Add Toppings`}
                      onClick={() => setOpenModifiers(true)}
                    />
                  }
                />
              )
            ) : null}
          </Grid>
        </Grid>

        {openSelection ? (
          <PizzaDialog
            open={openSelection}
            product={product}
            onProductAdd={handleAddToDeal}
            onClose={() => setOpenSelection(false)}
            showLoader={() => showLoader()}
            closeLoader={() => closeLoader()}
            defaultPizzaSizeId={pizzaSizeId}
          />
        ) : null}

        {openModifiers ? (
          <PizzaModifiersDialog
            open={openModifiers}
            onClose={() => setOpenModifiers(false)}
            steps={steps}
            variationConfig={variationConfig}
            variations={variations}
            onAddModifiers={handleAddModifiers}
          />
        ) : null}
        {showAlert ? (
          <AlertPopUp
            show={showAlert}
            message={alertMessage}
            onClose={() => handleAlert(false, "")}
            closeOnTimer={false}
          />
        ) : null}
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button color="error" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button onClick={handleSaveChanges}>Add to cart</Button>
      </DialogActions>
    </Dialog>
  );
};
